import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, reactive, toRaw, onBeforeMount } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import { cloneDeep } from 'lodash-es'
import { message } from '@dc-platform/dc-components'
import BusinessForm from './components/BusinessForm.vue'
import { goBack } from '@/hooks/cosRouter'
import { businessCreateOrEdit, businessDetails } from '@/api/overseasSales/chanceManage'
import type { FbuBusinessEditParams } from '@/typings/api/chanceManage'

const __default__ = { name: 'DcCosOFbuBusinessEdit' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute()
const { t } = useI18n()

const initForm: FbuBusinessEditParams = reactive({})
const dataForm = reactive<FbuBusinessEditParams>({})

onBeforeMount(() => {
  businessDetails({ id: route.query.id }).then((res) => {
    res.data.tailWarehouse = res.data.tailWarehouse || undefined
    res.data.tailProductName = res.data.tailProductName || undefined
    Object.assign(initForm, res.data)
    Object.assign(dataForm, res.data)
  })
})

const fetch = (val: any) => {
  Object.assign(dataForm, val)
}

const businessFormRef = ref()
const handleReset = () => {
  for (const key in dataForm) {
    dataForm[key] = undefined
  }
  Object.assign(dataForm, cloneDeep(initForm))
  setTimeout(() => {
    businessFormRef.value?.clearValidate()
  })
}
const loading = ref(false)
const handleSubmit = () => {
  businessFormRef.value?.validate().then(() => {
    loading.value = true
    const params = toRaw(dataForm)
    businessCreateOrEdit(params)
      .then(() => {
        message.success(t('business.sima2a'))
        businessFormRef.value?.resetFields()
        goBack()
      })
      .finally(() => {
        loading.value = false
      })
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_CosLayoutMain = _resolveComponent("CosLayoutMain")!

  return (_openBlock(), _createBlock(_component_CosLayoutMain, null, {
    content: _withCtx(() => [
      _createVNode(BusinessForm, {
        ref_key: "businessFormRef",
        ref: businessFormRef,
        title: _unref(t)('business.fx028r'),
        type: "edit",
        value: dataForm,
        "onUpdate:value": [
          _cache[0] || (_cache[0] = ($event: any) => ((dataForm) = $event)),
          fetch
        ]
      }, null, 8, ["title", "value"])
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_a_button, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(goBack)()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('btn.cancel')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_a_button, {
        loading: loading.value,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (handleReset()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('btn.reset')), 1)
        ]),
        _: 1
      }, 8, ["loading"]),
      _createVNode(_component_a_button, {
        type: "primary",
        loading: loading.value,
        onClick: _cache[3] || (_cache[3] = ($event: any) => (handleSubmit()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('btn.save')), 1)
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    _: 1
  }))
}
}

})